import {
  CAMPAIGN_METRICS,
  REP_STACK_METRICS,
  REP_TREND_METRICS,
  GATEWAY_METRICS,
} from '../componentKeys.js'

const identifiers = {
  key: 'revenuePerMachineHour',
  type: 'call',
  access: 'stats',
}

const formatting = {
  format: {
    title: 'Revenue / Machine Hour',
    prepend: '$',
  },
}

const keys = {
  componentKeys: [
    CAMPAIGN_METRICS,
    REP_STACK_METRICS,
    REP_TREND_METRICS,
    GATEWAY_METRICS,
  ],
  healthKey: 'metric_health',
}

const calculation = {
  calcType: 'divide',
  dividend: { stat: 'revenue' },
  divisor: { stat: 'machine_hours', convertTo: 'hours' },
}

const revenuePerMachineHour = {
  metaData: Object.assign(identifiers, formatting, keys, calculation),
  calculationConfig: calculation,
}

export { revenuePerMachineHour }
